import React, { useState } from "react";
import "../../../../../../Assets/Styles/AI.scss";
import DefaultImg from "../../../../../../Assets/Images/DefaultImg.svg";
import Alert from "../../../../Components/ShareElements/Alert/Alert";

/*
props:
- ImageSrc
- Name
- Status: success, failed, loading, cancelled
- UploadDate: mm-dd-yyyy
*/
const UploadWidgetPhoto = (props) => {
  const FileImage = props.ImageSrc || DefaultImg;
  const ImageSize = props.ImageSrc
    ? { height: "40px", width: "40px" }
    : { height: "24px", width: "24px" };

  const [ModalIsOpen, setModalIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const handleErrorType = (Err) => {
    let AllowedExtensions = [".png", ".jpg", ".jpeg", ".zip"];
    let FileExtension = props.Name.slice(
      props.Name.indexOf("."),
      props.Name.length
    );

    if (!AllowedExtensions.includes(FileExtension)) {
      return translateText("photo_uploader_validation_error_fiormat");
    } else {
      if (
        props.ErrorMessage === "photo_uploader_validation_error_file_size" ||
        props.ErrorMessage ===
          translateText("photo_uploader_validation_error_file_size") ||
        props.ErrorMessage ===
          "photo_uploader_validation_error_file_size_single" ||
        props.ErrorMessage ===
          translateText("photo_uploader_validation_error_file_size_single")
      ) {
        return translateText(
          "photo_uploader_validation_error_file_size_single"
        );
      } else {
        return props.ErrorMessage;
      }
    }
  };

  const toggleCancel = () => {
    setModalIsOpen(true);
  };

  const acceptCancellation = () => {
    setModalIsOpen(false);
    props.CancelUpload();
  };

  return (
    <div className="container-upload-widget-photo">
      {ModalIsOpen ? (
        <Alert
          AlertText={props.Name}
          Id={props.Id + "-modal"}
          cancel={() => setModalIsOpen(false)}
          AlertInfo={"Are you sure you want to cancel ?"}
          CancelText={"Close"}
          accept={() => acceptCancellation()}
          AcceptText={"Cancel upload"}
        />
      ) : null}
      <div className="upload-widget-photo">
        <img
          src={FileImage}
          alt=""
          className="uploaded-image"
          id={props.Id + "-preview"}
          width={ImageSize.width}
          height={ImageSize.height}
          loading="lazy"
        />
        <div className="description">
          <div className="image-name">{props.Name}</div>
          {props.Status === "loading" && props.Percentage < 100 ? (
            <div className="loading-container">
              <div
                className="loading-indicator"
                style={{ width: props.Percentage + "%" }}
              ></div>
            </div>
          ) : (
            <>
              {props.Status === "loading" && props.Percentage === 100 ? (
                <>
                  <i className="feather-loader upload-rotator"></i>
                </>
              ) : null}
            </>
          )}
        </div>
        {props.Status === "success" && (
          <div className="date-container">
            <i className="feather-calendar calendar-icon" />
            <span className="calendar-date">{props.UploadDate}</span>
          </div>
        )}
        {props.Status === "cancelled" && (
          <div id={props.Id + "-cancelled"} className="cancelled-description">
            {translateText("cancelled_by_user")}
          </div>
        )}
        {props.Status === "loading" && props.Percentage === 100 ? (
          <p className="processed-count">
            {props.ProcessedCount && props.TotalCount
              ? translateText("photo_uploader_processed_files") +
                " : " +
                props.ProcessedCount +
                "/" +
                props.TotalCount
              : translateText("photo_uploader_processed_files") + " : " + "0/0"}
          </p>
        ) : (
          <Button
            Status={props.Status}
            Percentage={props.Percentage}
            translateText={(Label) => translateText(Label)}
            HandleCancel={() => toggleCancel()}
          />
        )}
      </div>
      {props.Status === "failed" && (
        <div className="error-description">
          {handleErrorType(props.ErrorMessage)}
        </div>
      )}
    </div>
  );
};

//Status: success, loading, cancelled, failed
const Button = (props) => {
  if (props.Status === "success") {
    return <i className="feather-check check-icon" />;
  }
  if (props.Status === "loading") {
    return (
      <span
        className={
          props.Percentage < 100
            ? "cancel-btn"
            : "cancel-btn cancel-btn-disabled"
        }
        onClick={() => props.HandleCancel()}
      >
        {props.translateText("cancel")}
      </span>
    );
  }
  return <i className="feather-x cross-icon" />;
};

export default UploadWidgetPhoto;
